import { Alert } from 'antd';
import { errorMessage } from '../../lib/utils/messages';

const LoginErrorPage = () => {
  return (
    <Alert
      message={errorMessage.loginError}
      description={errorMessage.loginErrorDescription}
      type="error"
      showIcon
    />
  );
};

export default LoginErrorPage;
